import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import AllReportSubmissionsGrid from '@/components/reporting/allReportSubmissionsGrid'

@localized()
class AllReportSubmissions extends React.Component {
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Reporting.ReportSubmissionsTitle' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <AllReportSubmissionsGrid
            forecasting={false}
            detailUrlFormat='/report-submission-groups/{0}/report-submissions/{1}' />
        </MainBody>
      </Main>
    )
  }
}

export default AllReportSubmissions



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/submissions/allReportSubmissions.js